<template>
  <div id="sendcode_comp">
    <div class="fc-pointer" v-if="styleType == 'button'">
      <el-button v-if="startTimeDown">{{ downnum }}s{{$t('m.resend')}}</el-button>
      <el-button type="primary" v-else-if="isSendIng"><i class="el-icon-loading"></i></el-button>
      <el-button type="primary" @click="getcode()" v-else>{{$t('m.get_vercode')}}</el-button>
    </div>
    <div class="fc-pointer" v-else>
      <span v-if="startTimeDown">{{ downnum }}s{{$t('m.resend')}}</span>
      <span v-else-if="isSendIng"><i class="el-icon-loading"></i></span>
      <span @click="getcode()" v-else>{{$t('m.get_vercode')}}</span>
    </div>
    <div class="recaptcha_box" id="html_element" v-if="showRecaptcha"></div>
  </div>
</template>
<script>
import { sendcode } from "../api/common";
import { isMobileValid } from "@/utils/coding-utils";
// import func from 'vue-editor-bridge';
let widgetId1;
export default {
  props: {
    styleType: {
      type: String,
      default() {
        return "";
      },
    },
    mobile: {
      type: [Number,String],
      default() {
        return "";
      },
    },
    areaCode: {
      type: Number,
      default() {
        return null;
      },
    },
    scene: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      downnum: 60,
      startTimeDown: false, //是否开启倒计时
      timer: null,
      isSendIng: false, //是否发送中

      // 是否显示google令牌校验
      showRecaptcha:false,
      timestr:null,//时间戳
    };
  },
  mounted() {},
  methods: {
    countDown() {
      this.startTimeDown = true;
      this.timer = setInterval(() => {
        this.downnum--;
        if (this.downnum <= 0) {
          clearInterval(this.timer);
          this.startTimeDown = false;
          this.downnum = 60;
        }
      }, 1000);
    },
    getcode() {
      let _self=this;
      // let submit=this.submit();
      if (this.startTimeDown) return false;
      if (!isMobileValid(this.mobile)) {
        this.$message.error(this.$t('m.check_phone_istrue'));
        return false;
      }
      // google 令牌
      try {
        grecaptcha.enterprise.ready(async () => {
          _self.showRecaptcha=true;
          setTimeout(() => {
            widgetId1 = grecaptcha.enterprise.render('html_element', {
            'sitekey': '6LcZAC4iAAAAAFT79KK8szoInf4PidzZEmyJNO6o',
            "callback": function(){
              var token = grecaptcha.enterprise.getResponse(widgetId1);
              _self.sendCodeFun(token);
              _self.showRecaptcha=false;
            }
          })
          }, 500);
        });
      } catch (error) {
        console.log(error);
      }
    },
    //发送验证码
    sendCodeFun(token) {
      if (this.isSendIng) return false;
      this.isSendIng = true;

      let jsonData = {
        mobile: this.mobile,
        areaCode: this.areaCode,
        scene:this.scene,
        recaptchaToken:token
      };
      sendcode(jsonData).then(({ data }) => {
          this.isSendIng = false;
          console.log(data);
          if (data.code == 1) {
            this.countDown();
          } else {
            //  Toast(data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          //resolve(error)
          this.isSendIng = false;
        });
    },
  },
};
</script>
<style scoped lang="less">
.recaptcha_box{
  position: absolute;
  right: 0;
  z-index: 999;
  /* position: fixed;
  width: 320px;
  height: 400px;
  top: 50%;
  left: 50%;
  margin-left: -160px;
  margin-top: -200px;
  background-color: #fff;
  box-shadow: 1px 1px 5px #999;
  border-radius: 10px; */
}
.recaptchaitem{
  margin: auto;
}
.ar{
  .recaptcha_box{
    right: auto;
    left: 0;
  }
}
  @media only screen and (max-width: 767px){
    .recaptcha_box{
      position: fixed;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/sendcode.vue